import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

import $ from './core/Dom';
import Viewport from './core/Viewport';
import Components from './core/Components';
import lazySizes from './lib/lazysizes';
import ViewportHeight from './lib/ViewportHeight';

gsap.defaults({ overwrite: 'auto' });
gsap.registerPlugin(ScrollToPlugin);

const init = () => {
    Viewport.init();
    Viewport.initTabbing();
    ViewportHeight.init();

    pageInits();
};

const pageInits = () => {
    lazySizes.init();
    Components.init();
};

require('doc-ready')(init);
